<template>
  <div>
    <VerifyCheckHeader :img_header="header_image" header="รอตรวจสอบ" link_back="stock"/>
    <Verify_main/>
  </div>
</template>

<script>
import VerifyCheckHeader from "@/components/admin/stock/verify_check/headerverify_check/VerifyCheckHeader";
import HeaderImage from "@/assets/stamp_verify.png";
import Verify_main from "@/components/admin/stock/verify_check/Verify_main";
export default {
  name: "VerifyMain",
  components: {
    Verify_main,
    VerifyCheckHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  },
}
</script>

<style scoped>

</style>
